import { render } from "./pip.vue?vue&type=template&id=1c8ac98c"
import script from "./pip.vue?vue&type=script&lang=js"
export * from "./pip.vue?vue&type=script&lang=js"

import "./pip.vue?vue&type=style&index=0&id=1c8ac98c&lang=css"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__